type SharedStatusMessageVariant = "neutral" | "danger";

type SharedStatusMessageProps = {
  iconClass: string;
  title: string;
  description: string;
  variant?: SharedStatusMessageVariant;
};

const variantStyles = {
  neutral: { bg: "bg-gray-100", color: "text-gray-400" },
  danger: { bg: "bg-red-100", color: "text-red-400" },
};

export default function SharedStatusMessage({
  iconClass,
  title,
  description,
  variant = "neutral",
}: SharedStatusMessageProps) {
  const styles = variantStyles[variant];
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div
          className={`w-16 h-16 ${styles.bg} rounded-2xl flex items-center justify-center mx-auto mb-4`}
        >
          <i className={`${iconClass} text-3xl ${styles.color}`}></i>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </div>
  );
}
